import styled, { css } from 'styled-components';

import { ReactComponent as PopoverIcon } from '../../assets/icons/popover-icon.svg';
import colors from '../../styles/colors';
import Button from '../Button';
import Input from './components/Input';

const MessageInputWrapper = styled.div`
  display: flex;
  width: 100%;
  box-sizing: border-box;
  padding: ${({ $padding }) => ($padding)}px;
`;

const StyledInput = styled(Input)`
  border-radius: 5px 0 0 5px;
  border: 2px solid ${colors.base.secondary2};
  ${({ $isEditMessage }) => ($isEditMessage ? 'border-radius: 5px;' : 'border-right: none;')}
  ${({ $isScheduleMessage }) => $isScheduleMessage && css`
  border: 1px solid ${colors.shades.secondary7};
  `}
`;

const SubmitButton = styled(Button)`
  width: 40px;
  padding: 0;
  border-radius: 0 5px 5px 0;
  background: ${colors.base.secondary2};
  ${({ $isSchedulerEnabled }) => ($isSchedulerEnabled ? 'border-radius: 0;' : '')}

  &:disabled {
    background: ${colors.base.secondary2} !important;
    border-color: ${colors.base.beta} !important;
    border-width: 2px;
    border-style: solid;
  }
`;

const ScheduleMessageButton = styled(Button)`
  width: 20px;
  padding: 0;
  border-radius: 0 5px 5px 0;
  background: ${colors.base.secondary2};

  &:disabled {
    background: ${colors.base.secondary2} !important;
    border-color: ${colors.base.beta} !important;
    border-width: 2px;
    border-style: solid;
  }
`;

const StyledPopoverIcon = styled(PopoverIcon)`
  margin: 0;
  width: 20px;
  height: 20px;
  > path {
    stroke: ${colors.base.primary};
    fill: ${colors.base.primary};
  }
`;

export {
  MessageInputWrapper,
  StyledInput,
  SubmitButton,
  ScheduleMessageButton,
  StyledPopoverIcon,
};
